import { render, staticRenderFns } from "./CenterHero.vue?vue&type=template&id=242cbf46&"
import script from "./CenterHero.vue?vue&type=script&lang=js&"
export * from "./CenterHero.vue?vue&type=script&lang=js&"
import style0 from "./CenterHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports